module.exports = __webpack_public_path__ + "static/img/certificat_W.2ba82b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certificat_W.png
// module id = Rmee
// module chunks = 0